import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const KATEGORI_RENK: Record<string, string> = { 'genel': '#1890ff', 'onemli': '#ff4d4f', 'hatirlatma': '#ff9500', 'fikir': '#722ed1' };

@Component({
  selector: 'basit-not-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" [style.--sk-accent]="kategoriRenk()">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('baslik') || 'Isimsiz Not' }}</div>
        @if (deger('kategori')) { <span class="sk-chip">{{ deger('kategori') }}</span> }
      </div>
    </div>
  `,
})
export class BasitNotKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  kategoriRenk = computed(() => KATEGORI_RENK[this.deger('kategori')] || '#1890ff');
}
